import { openProjectEditorModal } from '../State/projectEditorModal'

export default () => (dispatch) => {

  dispatch(openProjectEditorModal())

}
